import { render, staticRenderFns } from "./AutologinInfo.vue?vue&type=template&id=8804c4d6"
import script from "./AutologinInfo.vue?vue&type=script&lang=js"
export * from "./AutologinInfo.vue?vue&type=script&lang=js"
import style0 from "./AutologinInfo.vue?vue&type=style&index=0&id=8804c4d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports